module.exports = __webpack_public_path__ + "img/svg_en.8a7e163a.svg";